import 'babel-polyfill/dist/polyfill.min.js'
import $ from 'jquery'
import _ from 'lodash'
import Anchor from 'view/anchor'
import Slider from 'view/slider'
import Drawer from 'view/drawer'
import Search from 'view/search'
import Menu from 'view/menu'
import TabDebut from 'view/tab-debut'
import AreaStyle from 'view/area-style'
window.jQuery = window.$ = $
require 'velocity'
require 'slick'
require 'remodal'

class Main
  constructor: ->
    # multiple new class
    { ps_cd } = @parameter()
    if ps_cd
      sessionStorage.setItem 'ps_cd', ps_cd

    newClass = (className, elm, opts) ->
      $elm = document.querySelectorAll elm
      _.forEach $elm, (_elm) ->
        if opts
          new className _elm, opts
        else
          new className _elm

    # single new class
    newClassSingle = (className, elm, opts) ->
      $elm = document.querySelectorAll elm
      if $elm.length
        if opts
          new className $elm, opts
        else
          new className $elm
    
    

    $ document
      .ready ->
        new Drawer
        new Menu
        # _.forEach [
        #   [ Navi, '.js-navi-button']
        #   [ FixedNavi, '.js-nav-stick']
        # ], (arr) ->
        #   newClassSingle.apply @, arr
        _.forEach [
          [ Anchor, 'a[href^="#"]']
          [ Slider, '.js-campaign-slider',
            option:
              infinite     : true
              dots         : true
              pauseOnHover : true
              autoplay     : true
              arrows       : false
              centerPadding: '0px'
          ]
          [ Slider, '.js-officeimg-slider',
            option:
              infinite     : true
              dots         : true
              arrows       : true
              pauseOnHover : true
              autoplay     : true
              centerPadding: '0px'
          ]
          [ Slider, '.js-kokokara-slider',
            option:
              infinite     : true
              dots         : true
              arrows       : true
              pauseOnHover : true
              variableWidth: true
              centerPadding: '0px'
          ]
          [ Search, '.js-search-box']
        ], (arr) ->
          newClass.apply @, arr

    $ window
      .on 'load', ->
        _.forEach [
          [ Slider, '.js-debut-slider',
            option:
              infinite     : true
              autoplay     : true
              dots         : true
              pauseOnHover : true
              variableWidth: true
              arrows       : true
              centerMode   : true
              # centerPadding: '0px'
            boxHeight: true
          ]
          [ TabDebut, '.js-tab-debut']
          [ AreaStyle, '.js-tab-style']
        ], (arr) ->
          newClass.apply @, arr


  parameter: ->
    v = []
    url = location.href.replace(/#.*$/, '')
    hashes = url.slice(window.location.href.indexOf('?') + 1).split('&')
    for key, hash of hashes
      h = hash.split('=')
      v.push(h[0])
      v[h[0]] = h[1]
    return v

export default Main



// WEBPACK FOOTER //
// ./webpack/imports/import.coffee